/* eslint-disable camelcase */
import React, { useState } from "react";
import { useTranslation } from "ceco-polyglot";
import { Accordion } from "semantic-ui-react";
import { MoreVertical, Edit, Delete } from "ceicons";
import Pill from "../Pill";
import { SectionModal } from "../../modals/SectionModal";
import { SectionDeleteModal } from "../../modals/SectionDeleteModal";
import IngredientRecipeModal from "../../modals/IngredientRecipeModal";
import { IngredientRecipeDeleteModal } from "../../modals/IngredientRecipeDeleteModal";
import DropDownButton from "../../DropDownButton";

import "./sectionAccordion.scss";

export default function SectionAccordion({
  section,
  recipeId,
  recipeName,
  allIngredients,
  allUnitMeasure,
  relayParent,
  refetchData,
  sectionId,
}) {
  const [active, setActive] = useState(false);
  const t = useTranslation();

  return (
    <div className="section accordion">
      <Accordion>
        <Accordion.Title
          className="section-menu"
          active={active}
          onClick={() => setActive(!active)}
        >
          <div className={`pill section`}>
            <span className="number"></span>
            <span className="text">{section?.name}</span>

            <DropDownButton icon={<MoreVertical />}>
              <SectionModal
                edit
                refetchData={refetchData}
                section={section}
                recipeId={recipeId}
                relayParent={relayParent}
                trigger={
                  <div>
                    <Edit />
                    <p>{t("popup.edit")}</p>
                  </div>
                }
              />

              <SectionDeleteModal
                refetchData={refetchData}
                recipeName={recipeName}
                section={section}
                relayParent={relayParent}
                sectionId={sectionId}
                recipeId={recipeId}
                trigger={
                  <div className="delete-modal">
                    <Delete />
                    <p>{t("popup.remove")}</p>
                  </div>
                }
              />
            </DropDownButton>
          </div>
        </Accordion.Title>

        <Accordion.Content active={active}>
          {section.ingredients.map((ingredient, i) => {
            return (
              <div className={`pill`} key={i}>
                <span className="number">{i + 1}</span>
                <span className="text">{ingredient.node.ingredient.name}</span>

                <DropDownButton icon={<MoreVertical />}>
                  <IngredientRecipeModal
                    recipeId={recipeId}
                    section={section?.node?.id}
                    edit
                    refetchData={refetchData}
                    ingredient={ingredient?.node}
                    allIngredients={allIngredients}
                    allUnitMeasure={allUnitMeasure}
                    trigger={
                      <div>
                        <Edit />
                        <p>{t("popup.edit")}</p>
                      </div>
                    }
                  />
                  <IngredientRecipeDeleteModal
                    recipeName={recipeName}
                    edit
                    refetchData={refetchData}
                    ingredient={ingredient?.node}
                    allIngredients={allIngredients}
                    allUnitMeasure={allUnitMeasure}
                    trigger={
                      <div className="delete-modal">
                        <Delete />
                        <p>{t("popup.remove")}</p>
                      </div>
                    }
                  />
                </DropDownButton>
              </div>
            );
          })}

          <IngredientRecipeModal
            recipeId={recipeId}
            refetchData={refetchData}
            allIngredients={allIngredients}
            section={section}
            allUnitMeasure={allUnitMeasure}
            trigger={
              <span>
                <Pill newItem text={t("pill.addIngredient")} />
              </span>
            }
          />
        </Accordion.Content>
      </Accordion>
    </div>
  );
}
